import React from 'react';
import { Column } from '@ant-design/plots';

const ColumnChartBill = (props) => {

    const config = {
        data: props.data,
        xField: 'type',
        yField: 'sales',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 1,
            },
            formatter: (datum) => {
                return Number(datum.sales).toFixed(2);
            },
        },
        color: ({ type }) => {
            switch (type) {
                case 'Pagos':
                    return '#3CB371';
                case 'Vencidos':
                    return '#f5222d';
                case 'A vencer':
                    return '#faad14';
                default:
                    return '#d9d9d9';
            }
        },
        xAxis: {
            label: {
                autoHide: false,
                autoRotate: false,
            },
        },
        meta: {
            type: {
                alias: 'R$',
            },
            sales: {
                alias: 'R$',
            },
        },
        animation: false,
        height: 200,
    };
    return <Column {...config} />;
};

export default ColumnChartBill